import LogoLoading from './LogoLoading';

export default LogoLoading;
